export default "__VITE_ASSET__DGSxdi5S__"